var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"base-icon icon-pause",attrs:{"role":"img","viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M28 12v40H12V12h16zm24 0v40H36V12h16z","fill":"currentColor","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }